export default __webpack_public_path__ + "static/Plots0084-94ebb4c1f18bcc36df0eecc8a8423338.jpg";